import type { ComponentType } from "react";
import { HomePageContentFallback } from "~/pages/HomePage/HomePageContentFallback";
import { ROUTES } from "~/utils";
import type { AppRouteHandle } from "~/types/routeHandle";
import { PageContentFallback } from "./PageContentFallback";
import { TableListPageContentFallback } from "./TableListPageContentFallback";

/** Pathname → content fallback. Used by RouterFallback (pre-match) and route `handle`. */
const contentFallbackByPath: Record<string, ComponentType> = {};

export function getContentFallbackForPathname(pathname: string): ComponentType {
  return contentFallbackByPath[pathname] ?? PageContentFallback;
}

function registerContentFallback(
  path: string,
  component: ComponentType,
): AppRouteHandle {
  contentFallbackByPath[path] = component;
  return { contentFallback: component };
}

export const homeRouteHandle = registerContentFallback(
  ROUTES.home,
  HomePageContentFallback,
);

export const unitListRouteHandle = registerContentFallback(
  ROUTES.unit,
  TableListPageContentFallback,
);

export const leaseListRouteHandle = registerContentFallback(
  ROUTES.lease,
  TableListPageContentFallback,
);

export const paymentTableRouteHandle = registerContentFallback(
  ROUTES.paymentTablePage,
  TableListPageContentFallback,
);
